<template>
  <div class="section-time">
    <key-value-unit
      title="监测开始"
      :value="reportDetailModel.startTimeStr"
    ></key-value-unit>
    <key-value-unit
      title="监测结束"
      :value="reportDetailModel.endTimeStr"
    ></key-value-unit>
    <key-value-unit
      title="监测时长"
      :value="reportDetailModel.totalSleepTimeStr"
    ></key-value-unit>
  </div>
</template>

<script>
import KeyValueUnit from "@c/report-detail/single-blood-oxygen-report/common/new-key-value-unit/key-value-unit-blood-oxygen-report.vue";
export default {
  components: {
    KeyValueUnit,
  },

  props: {
    reportDetailModel: Object,
  },
};
</script>

<style lang="scss" scoped>

.section-time {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>